import * as React from 'react';
import { flexTooltipHost } from '../../../../styles/iconStyles';
import { FontIcon, TooltipHost } from '@fluentui/react';
import { LanguageContext } from '../../../../../../utilities/LocalizationModule';

const teamSiteStyle: React.CSSProperties = {
    marginTop: 1,
    marginLeft: 5
}

export const TeamSiteIcon: React.FC<React.HTMLAttributes<HTMLElement>> = () => {
    const languageStrings = React.useContext(LanguageContext);

    return <TooltipHost content={languageStrings.TeamsSite} styles={flexTooltipHost}>
        <FontIcon iconName="TeamsLogo" style={teamSiteStyle} />
    </TooltipHost>
}